import { BackgroundColor } from '@ampcore/ampcom-contracts'

export const accoladesBackgroundColors = [
  BackgroundColor.STONE,
  BackgroundColor.MINT_TINT,
  BackgroundColor.LIME_TINT,
  BackgroundColor.PURPLE_TINT,
  BackgroundColor.BERRY_TINT,
  BackgroundColor.ORANGE_TINT,
  BackgroundColor.WHITE,
  BackgroundColor.TRANSPARENT,
  BackgroundColor.WHITE_FACET,
  BackgroundColor.MIDNIGHT_BLUE_FACET
] as const

export type AccoladesBackgroundColor =
  (typeof accoladesBackgroundColors)[number]
